<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { invoiceService } from "../../services/InvoiceService";
import pagination from "laravel-vue-pagination";
import OrderShow from "../orders/order_tabs/order-show";
import config from "../../config";
import { error_message, success_message, debounce , get_currency} from "../../Helper/helper";
/**
 * Invoice-list component
 */
export default {
  components: {
    Layout,
    PageHeader,
    pagination,
    OrderShow,
  },
  data() {
    return {
      currency: get_currency(),
      search: "",
      type: "",
      month: "",
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      config: config,
      orderId: "",
      title: "Invoice List",
      invoices: [],
      paginations: {},
      loading: true,
      showModal: false,
      // sortBy: "invoice_number",
      sortBy: "id",
      sortDesc: true,
      limit: 2,
      items: [
        {
          text: "Invoices",
          href: "/",
        },
        {
          text: "List",
          active: true,
        },
      ],
      fields: [
        { key: "invoice_number", label: "Invoice Number", sortable: false,thClass:"dis-event" },
        { key: "delivery_date", label: "Delivery Date", sortable: false,thClass:"dis-event" },
        { key: "customer_name", label: "Customer Name", sortable: true },
        { key: "amount", label: "Amount", sortable: true },
        { key: "payment_status", label: "Payment Status", sortable: true },
        { key: "payment_method", label: "Payment Method", sortable: true },
        {
          key: "action",
          label: this.trans.get("__JSON__.Action"),
          sortable: false,
          thClass:"dis-event"
        },
      ],
    };
  },
  mounted() {
    this.getInvoiceList();
  },
  methods: {
    getInvoiceList(page) {
      this.loading = true;
      invoiceService
        .getInvoices({
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
          page: page ? page : 1,
          type: this.type,
          search: this.search,
          month: this.month,
        })
        .then((response) => {
          this.loading = false;
          this.paginations = response.data.result;
          this.invoices = response.data.result.data;
          // console.log(this.invoices);
        });
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getInvoiceList();
    },
    downloadInvoice(id, invoice_file_name) {
      this.loading = true;
      invoiceService
        .downloadInvoice({
          invoiceId: id,
        })
        .then((response) => {
          if (invoice_file_name) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            var fileName = invoice_file_name;
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
            success_message("Invoice downloaded successfully");
          } else {
            error_message("Invoice not found");
          }
          this.loading = false;
        });
    },
    printInvoice(id,order_invoice_url){
      var url = config.appurl +'print-invoice/' +btoa(id + ',' + this.$auth.getVendorId());
      var winPrint = window.open(url);
      var fileURL = url
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("target", '_blank');
      fileLink.click();
      winPrint.print();
    },

    invoicePay(order_id) {
      this.loading = true;
      invoiceService
        .invoicePay({
          order_id: order_id,
        })
        .then((response) => {
          this.loading = false;
          this.getInvoiceList();
        });
    },

    onChange() {
      this.getInvoiceList();
    },

    searchData() {
      this.getInvoiceList();
    },

    monthChange() {
      this.getInvoiceList();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12 list-table-main">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-2 offset-sm-6">
                <div class="position-relative d-inline-block w-100">
                  <label for="">Invoice Type:</label>
                  <select
                    class="custom-select"
                    v-model="type"
                    @change="onChange()"
                  >
                    <option value="" selected>
                      {{ trans.get("__JSON__.All") }}
                    </option>
                    <option value="unpaid">
                      {{ trans.get("__JSON__.Open") }}
                    </option>
                    <option value="paid">
                      {{ trans.get("__JSON__.Paid") }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col">
                <div class="position-relative d-inline-block w-100">
                  <label for="">Month:</label>
                  <select
                    class="custom-select"
                    v-model="month"
                    @change="monthChange()"
                  >
                    <option value="" selected>All</option>
                    <option
                      :value="index + 1"
                      :key="index"
                      v-for="(monthName, index) in monthNames"
                      v-text="monthName"
                    ></option>
                  </select>
                </div>
              </div>

              <div class="col">
                <div class="search-box mr-2 mb-0 d-block form-group">
                  <div class="date-range-list">
                    <label>{{ trans.get("__JSON__.Search") }} :</label>
                    <div class="position-relative d-inline-block w-100">
                      <input
                        type="text"
                        class="form-control"
                        id="search"
                        @keyup="searchData()"
                        v-model="search"
                        :placeholder="
                          trans.get('__JSON__.Search By First Name, Last Name')
                        "
                      />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="
                  ol-12
                  table-main-list
                  customer-report-table
                  table-responsive
                "
              >
                <b-table
                  :items="invoices"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
                    </div>
                  </template>

                  <template v-slot:cell(amount)="data">
                    <div class="pt-3">
                      <p>{{  data.item.amount }} <span v-html="currency"></span></p>
                    </div>
                  </template>
                  <template v-slot:cell(payment_method)="data">
                    <div class="pt-3">
                      <span class="badge badge-pill font-size-12 badge-soft-warning">{{  data.item.payment_method }}</span>
                    </div>
                  </template>
                  <template v-slot:cell(action)="data">
                    <div>
                      <a
                        href="javascript:void(0)"
                        @click="
                          downloadInvoice(
                            data.item.id,
                            data.item.invoice_file_name
                          )
                        "
                        v-if="data.item.payment_status !== 'Unpaid'"
                      >
                      <i class="mdi mdi-download font-size-18"></i>
                      </a>

                      <button
                        type="button"
                        class="btn btn-success btn-sm btn-rounded"
                        v-if="data.item.payment_status == 'Unpaid'"
                        @click="invoicePay(data.item.order_id)"
                      >
                        <span> {{ trans.get("__JSON__.Mark as pay") }}</span>
                      </button>
                      <a
                        v-b-tooltip.hover.v-light
                        :title="trans.get('__JSON__.A4')"
                        href="javascript:void(0)"
                        @click="printInvoice(
                          data.item.id,
                          data.item.order_invoice_url)"
                        target="_blank"
                        ><i class="mdi mdi-printer font-size-18"></i
                      ></a>
                      <!-- <a
                        v-b-tooltip.hover.v-light
                        :title="trans.get('__JSON__.A4')"
                        :href="
                          config.appurl +
                          'print-invoice/' +
                          base64(data.item.id + ',' + $auth.getVendorId())
                        "
                        @click="printInvoice(
                          data.item.id,
                          data.item.invoice_file_name)"
                        target="_blank"
                        ><i class="mdi mdi-printer font-size-18"></i
                      ></a> -->
                       <!-- <a
                        v-b-tooltip.hover.v-light
                        :title="trans.get('__JSON__.A4')"
                        :href="`https://koalas-bucket.s3.eu-central-1.amazonaws.com/invoices/Koalas-00084.pdf`"
                        target="_blank"
                        ><i class="mdi mdi-printer font-size-18"></i
                      ></a> -->
                    </div>
                  </template>
                </b-table>
              </div>

              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getInvoiceList"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
